import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type RestoreOptimizationDto = ClientInferResponseBody<typeof contract.optimizations.restore>;

export const restoreOptimization = async ({
  optimizationId,
}: {
  optimizationId: string;
}): Promise<RestoreOptimizationDto> => {
  const response = await api.optimizations.restore.mutation({
    params: { id: optimizationId },
  });

  if (response.status !== 200) {
    throw new ApiError("Error restoring optimization", response.status, response.body);
  }

  return response.body;
};
